import type { Site } from '@hotjar/site';
import { getTrialInfo } from '@hotjar/webapp/domains/activation/trials/get-trial-info';
import type { AccountTrialInfo } from '../api/model';
import { useCurrentSiteAccount } from './useCurrentSiteAccount';
import { useOwnedAccount } from './useOwnedAccount';

export function useAccountTrialInfo(overrideSite?: Site | undefined): AccountTrialInfo | null {
  const { data: currentSiteAccount } = useCurrentSiteAccount();
  const { data: ownedAccount } = useOwnedAccount();

  const siteAccount = overrideSite ? overrideSite.account : currentSiteAccount;

  if (!siteAccount) {
    return null;
  }

  return getTrialInfo(siteAccount, ownedAccount);
}
